export enum HRToolsServices {
  ABSENCE_TYPES = "absence-types",
  ABSENCE_GROUPS = "absence-groups",
  CALENDARS = "calendars",
  EMPLOYEES = "employees",
  COMPANIES = "companies",
}
